import { createAsyncThunk } from '@reduxjs/toolkit';

import { InoAuthService } from '@/Module/Auth/Service';

export const authSendOtpCodeAction = createAsyncThunk<boolean, string>(
  'auth/sendOtpCode',
  async (phoneNumber, { signal, rejectWithValue }) => {
    return InoAuthService.sendOtpCode({ phoneNumber }, signal)
      .then(() => true)
      .catch(rejectWithValue);
  },
);
